import { ActionLink } from "@/components/ActionLink";
import { FeaturePanel } from "@/components/FeaturePanel";
import { SectionHeading } from "@/components/SectionHeading";
import { engineeringServiceCards, engineeringTracks, routeCtas } from "@/data/siteContent";

export function EngineeringPage() {
  return (
    <div>
      <section className="px-4 pb-20 pt-14 md:px-8 md:pt-20">
        <div className="mx-auto grid max-w-7xl items-center gap-10 md:grid-cols-[1.05fr_0.95fr]">
          <div className="space-y-7">
            <p className="eyebrow">Software engineering and consulting</p>
            <h1 className="font-display text-5xl leading-[1.03] text-text md:text-7xl">
              Good systems, built <span className="italic text-primary">on purpose</span>
            </h1>
            <p className="max-w-2xl text-lg leading-8 text-muted">
              I help teams build and improve .NET systems, cloud delivery, and architectural foundations without hiding
              the real tradeoffs behind buzzwords.
            </p>
            <div className="flex flex-wrap gap-4">
              {routeCtas["/engineering"].map((action, index) => (
                <ActionLink
                  key={action.label}
                  action={action}
                  variant={index === 0 ? "primary" : "secondary"}
                />
              ))}
            </div>
          </div>
          <div className="overflow-hidden rounded-[2rem] border border-outline/10 bg-surface-high">
            <img src="/assets/engineering/image-01.webp" alt="" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-surface-low px-4 py-24 md:px-8">
        <div className="mx-auto max-w-7xl space-y-12">
          <SectionHeading
            eyebrow="What I help with"
            title="Practical help, not vague transformation talk"
            description="The work ranges from hands-on implementation to architecture review and technical leadership, depending on what the team actually needs."
          />
          <div className="grid gap-8 md:grid-cols-3">
            {engineeringServiceCards.map((card) => (
              <FeaturePanel key={card.title} card={card} />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 py-24 md:px-8">
        <div className="mx-auto grid max-w-7xl gap-8 md:grid-cols-3">
          {engineeringTracks.map((card) => (
            <FeaturePanel key={card.title} card={card} />
          ))}
        </div>
      </section>
    </div>
  );
}

